export default __webpack_public_path__ + "static/media/diners.4beb1314.png";